import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './style.sass'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import nmaps from '@/../lib/n-maps/VueNMaps.ts'

Vue.use(nmaps, {
  provider: 'leaflet',
  options: {
    tiles: 'carto-light',
  },
  center: [39.223577, 9.121169]
})

import acl from './plugins/acl'

Vue.use(acl, {
  handler: (value: any, arg: any = 'can', modifiers: any) => {
    // console.log('handler here', value, arg, modifiers)
    if(value == '*'){
      return true
    }
    return false
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
